var OSS_TEMPLATES_LIST = require('./templates');

var URI = require('urijs');

var Run = function ($state, $log, $rootScope, apiService, customerModelService, StatesHistory, bootstrapParameters, vehicleService, $q, modelFactoryService, $timeout, authToken, LoaderService, SettingsConstants, $http, $templateCache, dealerModelService, $templateRequest, ssWidgetService, sdAnalyticsService, mobileCheckInService) {

    // intersept all states which are going to change
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        $log.info('State change start. ' + fromState.name + ' -> ' + toState.name);
    });
    // intersept all successful state changes
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        if (!toParams.skip) {
            StatesHistory.addState(toState.name, toParams);
            $log.info('State change success. ' + fromState.name + ' -> ' + toState.name);
        }
    });
    // intercept all errors during the state changing
    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
        $log.warn('State change error. ' + fromState.name + ' -> ' + toState.name);
        $log.warn(error);
    });

    $rootScope.appSettings = window.appSettings;
    $rootScope.moment = moment;
    $rootScope._ = _;
    $rootScope.go = $state.go;
    $rootScope.areCookiesEnabled = function () {
        var cookieEnabled = navigator.cookieEnabled ? true : false;

        if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled) {
            document.cookie = "testcookie";
            cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
        }

        return cookieEnabled;
    };

    $rootScope.normalizeUrl = function (path) {
        if (_.isEmpty(path)) return path;
        var uri = new URI(path);
        if (!uri.hostname()) {
            var serviceUri = new URI(window.appSettings.serverUrl);
            uri = uri.origin(serviceUri.origin());
        }
        return uri.toString();
    };

    // resolve authentication token
    var resolveTokenPromise = authToken.resolveToken(window.appSettings.authUrl)
        .then(function (res) {
            // init backend comunication process
            apiService.init();

            //create localization resources collection
            apiService.getCatalog().then(function (catalog) {
                return catalog.getMessages();
            }).then(function (messages) {
                $rootScope.appSettings.resources = _.fromPairs(messages.resources.map(function (item) {
                    return [item.key, item.value];
                }));
            }).catch(function (err) {
                $log.error('Could not get localization resources', err);
            });
        })
        .then(function () {
            // preload all templates
            return $q.all(_.map(OSS_TEMPLATES_LIST, $templateRequest));
        })
        .then(async function () {
            if (bootstrapParameters.getParameter('appointment')) {
                var existingAppointment,
                    currentVehicle;
                return modelFactoryService.getModel(bootstrapParameters.getParameter('appointment'), 'GET')
                    .then(function (appointment) {
                        existingAppointment = appointment;
                        return appointment.getCustomer();
                    })
                    .then(function (customer) {
                        customerModelService.setCustomer(customer);
                        customer.existingCustomer = true;
                        return existingAppointment.getVehicle();
                    })
                    .then(function (vehicle) {
                        currentVehicle = vehicleService.extend(vehicle);
                        customerModelService.setCurrentVehicle(currentVehicle);
                        existingAppointment.customerConcerns.forEach(function (el) {
                            el.selected = true;
                        });
                        existingAppointment.factoryRequiredServices.forEach(function (el) {
                            el.selected = true;
                        });
                        existingAppointment.dealerRecommendedServices.forEach(function (el) {
                            el.selected = true;
                        });
                        customerModelService.setDealerRecommendedServices(existingAppointment.dealerRecommendedServices);
                        customerModelService.setFactoryRequiredServices(existingAppointment.factoryRequiredServices);
                        customerModelService.setCustomerConcernsServices(existingAppointment.customerConcerns);
                        customerModelService.setCurrentAdviser(existingAppointment.serviceAdviser);
                        customerModelService.setCurrentTransportationOption(existingAppointment.transportationOption);
                        customerModelService.setCurrentScheduledTime(existingAppointment.scheduledTime);
                        currentVehicle.odometer = existingAppointment.odometer;
                        customerModelService.setConcernsDescription(existingAppointment.customerConcernsInfo);
                        return vehicle.make.getManufacturer();
                    })
                    .then(function (resolvedManufacture) {
                        customerModelService.getCurrentVehicle().setManufacturer(resolvedManufacture);
                    })
                    .finally(function () {
                        $state.go('summary');
                    });
            } else if (bootstrapParameters.getParameter('vin')) {
                //according to current reqirements if we have vin passed as
                //bootstrap parameter we should try to search this vin in
                //databse and according to search results deside what to
                //do - lead customer to the search result page or decode
                //vin and lead customer to the vehicle details page

                var vin = bootstrapParameters.getParameter('vin') || 'NULL';

                if (!(vin + '' && vin.length === 17)) {
                    return $timeout(function () {
                        SettingsConstants.APP_DEFAULT_STATE = 'createcustomer.manufacturer';
                        $state.go('createcustomer.manufacturer');
                    });
                }

                if (bootstrapParameters.getParameter('code')) {
                    var code = bootstrapParameters.getParameter('code') || 'NULL';
                    //var data = 'client_id=urn:oss&grant_type=authorization_code&code=' + code;
                    return verifyCustomer(vin, code)
                        .catch(function (err) {
                            $log.debug('Bypassing customer verification failed:', err);
                            return search();
                        });
                } else {
                    return search();
                }

                function verifyCustomer(vin, code) {
                    var vehiclePreview;
                    customerModelService.setSearchParameter(vin);
                    return customerModelService.searchCustomer(vin).then(function (result) {
                        if (result.length) {
                            vehiclePreview = result[0].vehicle;
                            var verifyParams = {
                                findValue: customerModelService.getSearchParameter(),
                                foundType: 'byVin',
                                verifyValue: code,
                                verifyType: 'byCode'
                            };

                            //ToDo need right way for getting customer if resultset recived.
                            return result[0].verify(verifyParams);
                        } else {
                            return $q.reject('Customer not found.');
                        }
                    }).then(function (result) {
                        var customer = result.customer;
                        if (customer) {
                            customer.existingCustomer = true;
                            customerModelService.setCustomer(customer, true);
                            return proceedVehicle(vehiclePreview);
                        } else {
                            return $q.reject('Customer property does not exist in API response.');
                        }
                    })
                        .catch(function (err) {
                            return $q.reject(err);
                        });
                }

                function proceedVehicle(vehiclePreview) {
                    var rVehicle;
                    return vehiclePreview.getVehicle().then(function (resolvedVehicle) {
                        rVehicle = resolvedVehicle;
                        customerModelService.setCurrentVehicle(vehicleService.extend(resolvedVehicle));
                        return resolvedVehicle.make.getManufacturer();
                    }).then(function (resolvedManufacture) {
                        customerModelService.getCurrentVehicle().setManufacturer(resolvedManufacture);
                        return rVehicle.getAppointments();
                    }).then(function (apptPreviews) {
                        //filter all future appointments and missed appointments
                        //if they were within the same day
                        var currentDay = moment().startOf('day');
                        var filtered = _.filter(apptPreviews.appointments, function (appt) {
                            return moment(appt.scheduledTime).startOf('day') >= currentDay;
                        });
                        var sorted = _.orderBy(filtered, function (o) { return moment(o.scheduledTime) }, 'asc');
                        customerModelService.setExistingAppointments(sorted);
                    })
                        .catch(function (err) {
                            $log.error('Something went wrong due to appointments acquiring');
                        })
                        .finally(function () {
                            $state.go('checkhealth');
                        });
                }

                function search() {

                    customerModelService.setSearchParameter(vin);
                    return customerModelService.searchCustomer(vin).then(function (result) {

                        if (result.length) {
                            customerModelService.setFoundCustomers(result);
                            //lead user to the search result page
                            SettingsConstants.APP_DEFAULT_STATE = 'searchresults';
                            $state.go('searchresults');
                        } else {
                            return apiService.getCatalog().then(function (catalog) {
                                return catalog.decodeVin(vin);
                            }).then(function (vehicle) {
                                var odometer = parseInt(bootstrapParameters.getParameter('mileage'));
                                if (!odometer) {
                                    SettingsConstants.APP_DEFAULT_STATE = 'createcustomer';
                                    $state.go('createcustomer', {vehicle: vehicle});
                                } else if (odometer && odometer <= 1000000) {
                                    SettingsConstants.APP_DEFAULT_STATE = 'bookappointment.concerns';
                                    $state.go('createcustomer', {vehicle: vehicle, odometer: odometer});
                                } else {
                                    $log.debug("parameter odometer is absent or not correct");
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    SettingsConstants.APP_DEFAULT_STATE = 'searchresults';
                                    $state.go('searchresults');
                                } else {
                                    $log.error(angular.toJson(err.data, true));
                                    SettingsConstants.APP_DEFAULT_STATE = 'createcustomer.manufacturer';
                                    $state.go('createcustomer.manufacturer');
                                }
                            });
                        }
                    });
                }
            }

            // $rootScope.appLoaded = false;
            $rootScope.appLoadState = {...$rootScope.appLoadState, value: false};
            //return timeout promise for preload map if redirected to welcome page
            return $timeout(function () {
                //$log.debug('maps loaded');
            }, 1000);
        })
        .catch(function (err) {
            $log.error('Could not get authentication token');
            $log.error(err);
        })
        .finally(function () {

            var themeUrl = undefined;

            switch (window.appSettings.currentThemeName) {
                case 'audi':
                    themeUrl = ':serverUrl/bundle/css/audi-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                case 'fca':
                    themeUrl = ':serverUrl/bundle/css/fca-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                case 'generic':
                    themeUrl = ':serverUrl/bundle/css/generic-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                case 'gm':
                    themeUrl = ':serverUrl/bundle/css/gm-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                case 'infiniti':
                    themeUrl = ':serverUrl/bundle/css/infiniti-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                case 'hyundai':
                    themeUrl = ':serverUrl/bundle/css/hyundai-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                case 'nissan':
                    themeUrl = ':serverUrl/bundle/css/nissan-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                case 'porsche':
                    themeUrl = ':serverUrl/bundle/css/porsche-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                case 'lexus':
                    themeUrl = ':serverUrl/bundle/css/lexus-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                case 'lexusmonogram':
                    themeUrl = ':serverUrl/bundle/css/lexusmonogram-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                case 'mitsubishi':
                    themeUrl = ':serverUrl/bundle/css/mitsubishi-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                case 'toyota':
                    themeUrl = ':serverUrl/bundle/css/toyota-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                case 'toyotasmartpath':
                    themeUrl = ':serverUrl/bundle/css/toyotasmartpath-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                case 'volkswagen':
                    themeUrl = ':serverUrl/bundle/css/volkswagen-surveys/surveys.css'
                        .replace(':serverUrl', window.appSettings.serverUrl);
                    break;
                default:
                    themeUrl = undefined;
                    break;
            }

            ssWidgetService.initWidget(
                themeUrl,
                authToken.getToken(),
                window.appSettings.currentDealerId,
                window.appSettings.currentCulture
            );

            if (!$rootScope.appLoadState?.notHideAutomatically) {
                $rootScope.appLoadState = {...$rootScope.appLoadState, value: true};
            } else {
                $rootScope.appLoadState = {...$rootScope.appLoadState, nextValue: true};
            }

            sdAnalyticsService.init();
            sdAnalyticsService.sendScheduleServiceImpression();

            $rootScope.$broadcast('appIsRunning');
        });

};

Run.$inject = ['$state', '$log', '$rootScope', 'apiService', 'customerModelService', 'StatesHistory', 'bootstrapParameters', 'VehicleService', '$q', 'modelFactoryService', '$timeout', 'authToken', 'LoaderService', 'SettingsConstants', '$http', '$templateCache', 'dealerModelService', '$templateRequest', 'ssWidgetService', 'sdAnalyticsService', 'mobileCheckInService'];

module.exports = Run;
